import Vue from "vue"
import VueRouter from "vue-router"

import ProductManual from "../views/ProductManual.vue"
Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    component: () =>
      import("../views/ProductManual"),
    redirect: "/ProductManual",
  },
  {
    path: "/ProductManual",
    name: "ProductManual",
    component: () =>
      import("../views/ProductManual"),
  },
  {
    path: "/ProductInfo",
    name: "ProductInfo",
    component: () =>
      import("../views/ProductInfo"),
  },
  {
    path: "/afterSales",
    name: "AfterSales",
    component: () =>
      import("../views/afterSales"),
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: () =>
      import("../views/maintenance"),
    meta: {
      keepAlive: false
    }
  },
  {
    path: "/progress/:id",
    name: "Progress",
    component: () =>
      import("../views/progress"),
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

export default router
